
export default {
  placesAndDirections: {
    isochrones: 'Isochronen',
    place: 'Ort',
    notRouteFound: 'Keine Route mit diesem Fahrzeugprofil für die gewählten Orte gefunden.',
    notRouteFoundWithFilters: 'Keine Route mit diesem Profil für die gewählten Einstellungen und Orte gefunden.',
    noPlaceFound: 'Kein Ort mit diesen Angaben gefunden',
    routeReady: 'Route fertig',
    useLocation: 'Mein Standort nutzen',
    addPlaceInput: 'Ort hinzufügen',
    clearRoute: 'Route zurücksetzen',
    reverseRoute: 'Route invertieren',
    orderByClosestPlaces: 'Nach Entfernung anordnen',
    calculatingRoute: 'Route wird berechnet ...',
    yourLocation: 'Mein Standort',
    expandAltitudeChart: 'Höhenprofil vergrößern',
    errorRenderingContentUploaded: 'Fehler beim anzeigen des hochgeladenen Objekts. Bitte Format und Inhalt überprüfen.',
    roundTrip: 'Rundweg',
    notPossibleToCalculateRoute: 'Keine Route zwischen den gewählten Orten gefunden.',
    apiError: {
      2000: 'Umwandlung der JSON Anfrage nicht möglich.',
      2001: 'Pflichtparameter fehlt',
      2002: 'Ungültiges Parameter Format',
      2003: 'Routenparameter überschreiten eine oder mehrere Grenzen. Bitte denken Sie an limits bei vermeidbaren Objekten (z.B. max. 20.000 Quadratkilometer für Avoid Polygone)',
      2004: 'Routenparameter überschreiten einen oder mehrere Grenzwerte. Denken Sie daran, dass die ungefähre Streckenlänge nicht mehr als 6000 km betragen darf. Wenn bestimmte Routenoptionen oder vermeidbare Routen verwendet werden, darf die ungefähre Routenentfernung nicht mehr als 150 km betragen.',
      2006: 'Umwandeln der Anfrage zum Export Handler nicht möglich',
      2007: 'Export Format nicht unterstützt',
      2008: 'Leeres Element',
      2009: 'Es konnte keine geeignete Route mit den angegebenen Orten und Parametern gefunden werden. Möglicherweise wird das angegebene Profil in diesem Bereich / dieser Region mit den angewendeten Filtern nicht unterstützt.',
      2010: 'Mindestens ein Wegpunkt wurde nicht gefunden. Es sollte sich ein, für das Fahrzeugprofil zugänglicher, Weg in 350m Umkreis um jeden Wegpunkt befinden.',
      2011: 'Inkompatible Parameter.',
      2012: 'Unbekannter Anfrage Parameter.',
      2099: 'Unbekannter interner Fehler. Bitte support[at]openrouteservice.heigit.org kontaktieren.'
    },
    genericErrorMsg: 'Keine Route gefunden',
    reorder: 'Neu ordnen'
  }
}
